import { getDb } from '../LocalDB/LocalDB';
import { type SquawkDeferral } from './types';

export async function getSquawkDeferralsForSquawk(squawkId: string): Promise<SquawkDeferral[]> {
    return getDb().squawkDeferrals.where({ squawkId }).sortBy('createdAt');
}
